module.exports = __webpack_public_path__ + "img/KH.dd6a5746.svg";